import React from "react";
import { Route, Redirect } from "react-router";
import { get as getCookie } from 'es-cookie';

export const AuthRoute = ({ component: Component, ...rest }:any) => (
    <Route {...rest} render={props => (
        (getCookie("token") && getCookie("token") != "")
        ? <Component {...props} />
        : <Redirect to={{ pathname: "/login", state: { from: props.location }}} />
    )} />
);